import React from "react";
import Star from "~/components/Star";
import Colors from "~/constants/colors";
import { getConfig } from "~/utils/theme";

type StepReviewRateProps = {
  form?: any;
  onSlickNext?: any;
};

const StepReviewRate = ({ form, onSlickNext }: StepReviewRateProps) => {
  const themeConfig = getConfig("Common");
  return (
    <div className="flex flex-col justify-center items-center">
      <p className="mb-6">How would you rate this item?</p>
      <div className="flex flex-col gap-[2px]">
        <Star
          isEdit
          value={form.values.star}
          onChange={(v) => {
            form.setFieldValue(`star`, v);
            onSlickNext();
          }}
          size={56}
          colorActive={themeConfig.starActiveColor}
          colorInActive={Colors.GREY_100}
        />
        <div className="flex justify-between w-full mt-1">
          <span>Dislike it</span>
          <span>Love it</span>
        </div>
      </div>
    </div>
  );
};

export default StepReviewRate;
